import { createFileRoute, redirect } from '@tanstack/react-router';

// Kept so existing links and bookmarks land on the new-investigation screen,
// which is now the section's index.
export const Route = createFileRoute('/$organizationName/investigations/new')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$organizationName/investigations', params, replace: true });
  },
});
